import React, { useEffect, useState } from "react";
import SinglePlaceCard from "../components/SinglePlaceCard";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import SuccessAlert from "../components/SuccessAlert";
import ErrorAlert from "../components/ErrorAlert";
import NothingToShow from "../../components/NothingToShow";

export default function Places() {
  // State Handling
  const [placesData, setPlacesData] = useState({
    place_img: "",
    place_country: "",
    place_city: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [fetchedData, setFetchedData] = useState([]);
  const [loading, setLoading] = useState(false);

  // --------- Reading/Fetching Places From Database ---------
  const readingData = async () => {
    const response = await fetch("https://hotelbnb-backend.onrender.com/read-places");
    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Places can't be fetched");
    } else if (response.ok) {
      setTimeout(() => {
        setError("");
      }, 10000);
      setFetchedData(result);
    }
  };

  useEffect(() => {
    readingData();
  }, []);

  // --------- Creating ---------
  // Upload Image Handling
  const placeImgHandler = (e) => {
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setPlacesData({
          ...placesData,
          place_img: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  // Form Submission To Add Place In DataBase
  const placesSubmitHandler = async (e) => {
    window.scrollTo(0,0);
    e.preventDefault();
    setLoading(true);

    try {
      // Sending Data to Database
      const response = await fetch("https://hotelbnb-backend.onrender.com/add-places-toDb", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(placesData),
      });

      // Checking Response and setting success or error messages
      if (!response.ok) {
        setSuccess("");

        if (response.status === 413) {
          setError("Image is too big, Max Image Size = 1mb");
        } else {
          setError("Error Occurred, Something went wrong");
        }
      } else {
        setError("");
        setSuccess("Place Added Successfully");

        setTimeout(() => {
          setSuccess("");
        }, 2000);

        // Clearing The Form
        setPlacesData({
          place_img: "",
          place_country: "",
          place_city: "",
        });
      }
    } catch (error) {
      console.log(error);
    }  finally {
      setLoading(false);
    }

    // Reading the places again so that it shows the newly added place as well
    readingData();
  };

  // --------- Deleting ---------
  const deleteHandler = async (placeCity) => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/delete-place/${placeCity}`,
      {
        method: "DELETE",
      }
    );

    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Place can't be deleted");
    } else if (response.ok) {
      setError("");
      setSuccess("Place Deleted Successfully");

      setTimeout(() => {
        setSuccess("");
      }, 2000);
    }

    // Reading the places again
    readingData();
  };

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Adding Place</p>
      </div>
    );

  if (!loading)
  return (
    <>
      {/* Showing Alert based on http request response Start */}
      {success && <SuccessAlert successMsg={success} />}
      {error && <ErrorAlert errorMsg={error} />}
      {/* Showing Alert based on http request response End */}

      {/* Add Places Heading Start */}
      <AdminPanelGeneralHeading text="Add New Place" />
      {/* Add Places Heading End */}

      {/* Add Places Form Start */}
      <div className="col-12 add-places-form-cover signup-form-cover">
        <form method="post" className="p-0" onSubmit={placesSubmitHandler}>
          {/* Row 1 */}
          <div className="d-flex justify-content-center align-items-center">
            <div className="p-0 m-0 upload-place-hotel-pic-cover upload-profile-pic-cover d-flex justify-content-center align-items-center position-relative">
              <i className="fa-solid fa-camera"></i>
              <input
                type="file"
                name="place_img"
                required
                className="profile-pic-input"
                onChange={placeImgHandler}
              />
              {placesData.place_img ? (
                <img
                  src={placesData.place_img}
                  alt="place-img"
                  className="img-fluid"
                />
              ) : (
                ""
              )}
            </div>
          </div>

          {/* Row 2 */}
          <div className="d-flex gap-3 signup-form-row">
            <div className="col p-0 signup-col">
              <input
                type="text"
                name="place_country"
                required
                placeholder="Country (ex: Canada)"
                className="form-control text-capitalize"
                value={placesData.place_country}
                onChange={(e) => {
                  setPlacesData({
                    ...placesData,
                    place_country: e.target.value.toLowerCase(),
                  });
                }}
              />
            </div>
            <div className="col p-0 signup-col">
              <input
                type="text"
                name="place_city"
                placeholder="City (ex: Toronto)"
                required
                className="form-control text-capitalize"
                value={placesData.place_city}
                onChange={(e) => {
                  setPlacesData({
                    ...placesData,
                    place_city: e.target.value.toLowerCase(),
                  });
                }}
              />
            </div>
          </div>

          {/* Submit Btn */}
          <button
            type="submit"
            className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
          >
            Add Place
          </button>
        </form>
      </div>
      {/* Add Places Form End */}

      {/* All Places Heading Start */}
      <AdminPanelGeneralHeading
        text="All The Places"
        classes="admin-panel-all-general-heading"
      />
      {/* All Places Heading End */}

      {/* All Places Cards Start */}
      <div className="col-12 all-places-cover d-flex flex-wrap justify-content-start align-items-center">

      {!fetchedData.length ? <NothingToShow /> : ""}

        {fetchedData?.map((singlePlace) => {
          return (
            <SinglePlaceCard
              key={singlePlace._id}
              placeImg={singlePlace.place_img}
              placeCity={singlePlace.place_city}
              placeCountry={singlePlace.place_country}
              deleteHandler={deleteHandler}
            />
          );
        })}
      </div>
      {/* All Places Cards End */}
    </>
  );
}
